import icon from 'assets/cashman/rarity-star.png';

export const LocalImage: React.FC = () => (
  <div>
    heres your local star
    <img alt="icon" src={icon} />
  </div>
);
